<div *ngIf="errorObject">
  <div *ngFor="let apiNumber of globalErrorApiNumbers">
    <div *ngFor="let error of errorObject[apiNumber]; let i = index">
      <ng-container *ngIf="error.apiNumber === apiNumber">
        <div [ngClass]="!isFractionalPage && !dormancyCheck ? 'm-t-md m-b-sm' : 'col-xs-8'">
          <ng-container *ngIf="error.userMessage">
            <p
              id="errorMessage0"
              [ngClass]="{
                'error-text': !dormancyCheck,
                'error-container': dormancyCheck,
                'container-full-width': dormancyCheck,
              }"
            >
              <i
                *ngIf="!dormancyCheck"
                class="fa fa-exclamation-circle def error-icon"
                (click)="showDetails[i] = !showDetails[i]"
              ></i>
              <i
                *ngIf="dormancyCheck"
                class="fa fa-exclamation-triangle pe-4 exclamation-circle-icon"
              ></i>
              <span [innerHTML]="error?.userMessage"></span>
            </p>
          </ng-container>
          <div
            *ngIf="showDetails[i] && !isProdEnabled"
            class="radio-check-spacer break-words m-t-xs"
          >
            <p class="legal"><strong>Status Code:</strong> {{ error?.code }}</p>
            <p class="legal"><strong>System Message:</strong> {{ error?.systemMessage }}</p>
            <p class="legal"><strong>User Message:</strong> {{ error?.userMessage }}</p>
            <p class="legal"><strong>Api Number:</strong> {{ error?.apiNumber }}</p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<!--<div *ngIf="errorText">
  <p class="error-text">
    <i class="fa fa-exclamation-circle def error-icon"></i>{{errorText}}
  </p>
</div>-->
